// extracted by mini-css-extract-plugin
module.exports = {"contenidorImatge":"IntroduccioIndividuFenofasesDetallImatge_contenidorImatge__2YOLE","IntroduccioFoto":"IntroduccioIndividuFenofasesDetallImatge_IntroduccioFoto__1m2Zu"};